module.exports = ".addon{\n  width: 25px !important;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/home/home.component.css
// module id = ./src/app/home/home.component.css
// module chunks = main